import baseAPI from "@/http";

export const radarExecucaoAPI = {
  obter: (filter = {}) => baseAPI.post("api/dashboard/radarexecucao", filter),
};
